module.exports = __webpack_public_path__ + "img/ck_sx.33e5d64b.png";